import { gql } from '@apollo/client'

const lot = gql`
  query lot($id: Int!) {
    lot(id: $id) {
      about
      address {
        ... on UsAddress {
          city
          state
        }
      }
      amenities {
        label
        code
      }
      countryCode
      directionsNotes
      id
      mainPhoto {
        image {
          info {
            url
          }
          fallbackUrl
        }
      }
      name
      notes
      parkingInstructionsCategory
      rawAddress
      timezoneName
    }
  }
`

export default lot
